import { formatPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

import usePageProps from '../../hooks/Inertia/usePageProps';

type PhoneNumberDisplayProps = {
    children?: string;
};

const PhoneNumberDisplay = ({ children }: PhoneNumberDisplayProps) => {
    const page = usePageProps();

    if (!children) {
        return null;
    }

    const referenceCountry = page.tenant.countryCode;

    const phoneNumber = parsePhoneNumber(children);
    if (
        !referenceCountry ||
        !phoneNumber ||
        !phoneNumber.country ||
        phoneNumber.country !== referenceCountry
    ) {
        return <span>{children}</span>;
    }

    return <span>{formatPhoneNumber(children)}</span>;
};

export default PhoneNumberDisplay;
